const draftOrder = JSON.parse(localStorage.getItem("draftOrder")) || [];
const popup = document.querySelector(".draft-order-popup");
const overlay = document.querySelector(".draft-order-overlay");

document.addEventListener("click", async (e) => {
  const button = e.target.closest(".open-draft-order-popup");
  if (!button) return;

  e.preventDefault();

  const productHandle = button.dataset.productHandle;
  const productItem = button.closest("product-block");

  const productTitle = productItem
    .querySelector(".product-block__title")
    .innerText.trim();

  const imgEl = productItem.querySelector("img");
  const productImage = imgEl?.src || null;

  const product = await fetch(`/products/${productHandle}.js`).then((res) =>
    res.json()
  );

  popup.classList.remove("hidden");

  document.querySelector(".popup-product-title").innerText = productTitle;
  
  const imageWrapper = document.querySelector(".popup-product-image");

  imageWrapper.innerHTML = productImage
    ? `<img src="${productImage}" alt="${productTitle}" />`
    : `<div class="placeholder-image">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>
      </div>`;
  
  document.querySelector(".popup-product-price").innerText = `$${(
    product.price / 100
  ).toFixed(2)} AUD`;

  const variantsContainer = document.querySelector(".popup-variants");
  variantsContainer.innerHTML = `
            <div class="variants-header">
                <span>Variant</span>
                <span>Quantity</span>
                <span>Price</span>
                <span>Variant Total</span>
            </div>
        `;

  product.variants.forEach((variant) => {
    const variantRow = document.createElement("div");
    variantRow.classList.add("variant-row");

    const quantityInputHTML = `
                <div class="variant-quantity quantity buttoned-input">
                    <button class="decrease quantity__button">-</button>
                    <input class="quantity__input" 
                        type="number" 
                        min="0" 
                        value="0" 
                        data-variant-id="${variant.id}" 
                        data-price="${variant.price}">
                    <button class="increase quantity__button">+</button>
                </div>
            `;

    variantRow.innerHTML = `
                <div class="variant-info">
                    <div class="variant-title">${variant.title}</div>
                    <div class="variant-sku">${variant.sku}</div>
                </div>
                ${quantityInputHTML}
                <div class="variant-price">$${(variant.price / 100).toFixed(
                  2
                )}/ea</div>
                <div class="variant-total">$0.00</div>
            `;

    variantsContainer.appendChild(variantRow);
  });

  updateTotals();

  variantsContainer
    .querySelectorAll(".increase, .decrease")
    .forEach((button) => {
      button.addEventListener("click", (ev) => {
        const input = ev.currentTarget.parentElement.querySelector("input");
        let currentValue = parseInt(input.value, 10);
        if (ev.currentTarget.classList.contains("increase")) {
          currentValue++;
        } else if (
          ev.currentTarget.classList.contains("decrease") &&
          currentValue > 0
        ) {
          currentValue--;
        }
        input.value = currentValue;
        updateRowTotal(input);
        updateTotals();
      });
    });

  variantsContainer
    .querySelectorAll('input[type="number"]')
    .forEach((input) => {
      input.addEventListener("input", () => {
        updateRowTotal(input);
        updateTotals();
      });
    });

  function updateRowTotal(input) {
    const price = parseFloat(input.dataset.price) / 100;
    const quantity = parseInt(input.value, 10) || 0;
    const total = price * quantity;
    const row = input.closest(".variant-row");
    row.querySelector(".variant-total").innerText = `$${total.toFixed(2)}`;
  }

  function updateTotals() {
    let totalItems = 0;
    let totalPrice = 0;

    variantsContainer
      .querySelectorAll('input[type="number"]')
      .forEach((input) => {
        const quantity = parseInt(input.value, 10) || 0;
        const price = parseFloat(input.dataset.price) / 100;
        totalItems += quantity;
        totalPrice += quantity * price;
      });

    document.querySelector(".popup-total-items").innerText = totalItems;
    document.querySelector(
      ".popup-total-price"
    ).innerText = `$${totalPrice.toFixed(2)}`;
  }

  popup.classList.remove("hidden");
  overlay.classList.remove("hidden"); // Show overlay
  overlay.style.display = "block"; // Ensure it's visible
});

document.querySelector(".add-to-draft-order").addEventListener("click", () => {
  const imgEl = document.querySelector(".popup-product-image img");
  const productImage = imgEl?.src || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAW1JREFUeF7t1VEJADAMxNDVv9da2GAq8vGqICQcnd29x2UMjCCZFh9EkFYPQWI9BBGkZiDG44cIEjMQw7EQQWIGYjgWIkjMQAzHQgSJGYjhWIggMQMxHAsRJGYghmMhgsQMxHAsRJCYgRiOhQgSMxDDsRBBYgZiOBYiSMxADMdCBIkZiOFYiCAxAzEcCxEkZiCGYyGCxAzEcCxEkJiBGI6FCBIzEMOxEEFiBmI4FiJIzEAMx0IEiRmI4ViIIDEDMRwLESRmIIZjIYLEDMRwLESQmIEYjoUIEjMQw7EQQWIGYjgWIkjMQAzHQgSJGYjhWIggMQMxHAsRJGYghmMhgsQMxHAsRJCYgRiOhQgSMxDDsRBBYgZiOBYiSMxADMdCBIkZiOFYiCAxAzEcCxEkZiCGYyGCxAzEcCxEkJiBGI6FCBIzEMOxEEFiBmI4FiJIzEAMx0IEiRmI4ViIIDEDMRwLESRmIIZjIYLEDMRwHo3Qevj9D50JAAAAAElFTkSuQmCC';
  const productName = document
    .querySelector(".popup-product-title")
    .innerText.trim();

  document.querySelectorAll(".popup-variants input").forEach((input) => {
    const quantity = parseInt(input.value, 10);
    const variantId = parseInt(input.dataset.variantId, 10);
    const price = parseFloat(input.dataset.price) / 100;
    const variantTitle = input
      .closest(".variant-row")
      .querySelector(".variant-title")
      .innerText.trim();

    if (quantity > 0) {
      const existingItem = draftOrder.find(
        (item) => item.variant_id === variantId
      );

      if (existingItem) {
        existingItem.quantity += quantity;
        existingItem.totalPrice = existingItem.quantity * price;
      } else {
        draftOrder.push({
          product_name: productName,
          variant_id: `gid://shopify/ProductVariant/${variantId}`,
          variant_title: variantTitle,
          quantity: quantity,
          price: price,
          totalPrice: quantity * price,
          image: productImage,
        });
      }
    }
  });

  localStorage.setItem("draftOrder", JSON.stringify(draftOrder));

  updateDraftOrderSidebar();
  closePopup();
});

function toggleMobileDraftOrderButton() {
  const button = document.querySelector(".view-draft-order-button");
  if (window.innerWidth <= 768 && draftOrder.length > 0) {
    button.classList.add("visible");
  } else {
    button.classList.remove("visible");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  toggleMobileDraftOrderButton();
  updateDraftOrderSidebar(); 
});

function updateDraftOrderSidebar() {
  const desktopList = document.querySelector(
    ".draft-order-summary-list.desktop"
  );
  const mobileList = document.querySelector(".draft-order-summary-list.mobile");
  const submitButtonDesktop = document.querySelector(
    ".submit-draft-order.desktop"
  );
  const submitButtonMobile = document.querySelector(
    ".submit-draft-order.mobile"
  );

  [desktopList, mobileList].forEach((list) => {
    if (!list) return;

    list.innerHTML = "";

    if (draftOrder.length === 0) {
      list.innerHTML = "<li>Your draft order is empty.</li>";
      submitButtonDesktop.style.display = "none";
      submitButtonMobile.style.display = "none";
      desktopList.classList.remove("active");
      mobileList.classList.remove("active");
    } else {
      submitButtonDesktop.style.display = "block";
      submitButtonMobile.style.display = "block";
      desktopList.classList.add("active");
      mobileList.classList.add("active");
    }

    let totalItems = 0;
    let subtotal = 0;

    draftOrder.forEach((item, index) => {
      totalItems += item.quantity;
      subtotal += item.totalPrice;

      const li = document.createElement("li");
      li.classList.add("draft-order-item");

      li.innerHTML = `
                <div class="draft-order-item-image">
                    <img src="${item.image}" alt="${item.product_name} - ${
        item.variant_title
      }">
                </div>
                <div class="draft-order-item-info">
                    <div class="product-name">${item.product_name}</div>
                    <div class="product-variant-price">${
                      item.variant_title
                    } - $${item.price.toFixed(2)}</div>
                    <div class="product-variant-quantity">
                        Qty: ${item.quantity}
                    </div>
                </div>
                <div class="variant-total-price">
                    $${item.totalPrice.toFixed(2)}
                    <br/><br/>
                    <button data-index="${index}" class="remove-item">Remove</button>
                </div>
            `;

      list.appendChild(li);
    });

    localStorage.setItem("draftOrder", JSON.stringify(draftOrder));

    const summary = document.createElement("li");
    summary.classList.add("draft-order-summary-total");
    summary.innerHTML = `
            <div class="draft-order__notes">
                <textarea id="draft-order-notes" placeholder="Add a note..." height="100"></textarea>
                <input type="text" id="draft-order-ponumber" name="po_number" placeholder="PO Number" />
            </div>

            <div>Total Items: <strong>${totalItems}</strong></div>
            <div>Subtotal: <strong>$${subtotal.toFixed(2)}</strong></div>
        `;
    list.appendChild(summary);

    // Reattach remove button listeners for this list
    list.querySelectorAll(".remove-item").forEach((button) => {
      button.addEventListener("click", (e) => {
        const index = parseInt(e.currentTarget.dataset.index, 10);
        draftOrder.splice(index, 1);
        updateDraftOrderSidebar();
        toggleMobileDraftOrderButton();
      });
    });
  });

  toggleMobileDraftOrderButton();
}

document.querySelectorAll(".submit-draft-order").forEach((button) => {
  button.addEventListener("click", async (e) => {
    e.preventDefault();

    const parentContainer = button.closest(".draft-order-summary");
    const messageContainer = parentContainer.querySelector(".draft-order-message");

    // 🕒 Wait for B2B data (max 2s)
    const waitForData = async (maxWait = 2000) => {
      const interval = 100;
      let waited = 0;
      while (!window.b2bDataReady && waited < maxWait) {
        await new Promise((res) => setTimeout(res, interval));
        waited += interval;
      }
      return window.b2bDataReady;
    };

    const b2bReady = await waitForData();

    if (!b2bReady || !window.customer) {
      messageContainer.innerHTML = `<span class="error">Unable to load company details. Please refresh the page and try again.</span>`;
      return;
    }

    const customerId = window.customer.id;
    const companyId = window.customer.company_id;
    const companyContactId = window.customer.company_contact_gid;
    const companyLocationId = window.customer.company_location_gid;

    if (!companyId || !companyContactId || !companyLocationId) {
      messageContainer.innerHTML = `<span class="error">Company details incomplete. Please refresh and try again.</span>`;
      return;
    }

    const note = document.querySelector("#draft-order-notes")?.value.trim() || "";
    const poNumber = document.querySelector("#draft-order-ponumber")?.value.trim() || "";

    // 🧪 Validate lineItems (optional)
    if (!Array.isArray(draftOrder) || draftOrder.length === 0) {
      messageContainer.innerHTML = `<span class="error">Your draft order is empty.</span>`;
      return;
    }

    // ✅ Start submission
    messageContainer.innerHTML = `
      <span class="loading">
        <span class="loader"></span>
        Submitting draft order, please wait...
      </span>`;

    fetch("https://b2b-draft-order.onrender.com/api/create-draft-order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        lineItems: draftOrder.map((item) => ({
          variantId: item.variant_id,
          quantity: item.quantity,
        })),
        note,
        poNumber,
        purchasingEntity: {
          purchasingCompany: {
            companyId,
            companyContactId,
            companyLocationId,
          },
        },
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          messageContainer.innerHTML = `<span class="success">Draft order created successfully! Our team will contact you shortly.</span>`;
          draftOrder.length = 0;
          setTimeout(() => localStorage.removeItem("draftOrder"), 100);
          updateDraftOrderSidebar();
        } else {
          const errorText = Array.isArray(data.errors)
            ? data.errors.join(", ")
            : typeof data.errors === "string"
            ? data.errors
            : JSON.stringify(data.errors);
          messageContainer.innerHTML = `<span class="error">Error creating draft order: ${errorText}</span>`;
          console.log("[Draft Order Error Response]", data);
        }
      })
      .catch((err) => {
        console.error(err);
        messageContainer.innerHTML = `<span class="error">An error occurred. Please try again later.</span>`;
      });
  });
});

 
document.querySelector(".close-popup").addEventListener("click", () => {
  closePopup();
});

// Close when clicking outside the popup (on the overlay)
overlay.addEventListener("click", () => {
  closePopup();
});

// Optional: Close if clicking directly on the background area of the popup itself (outside its content)
popup.addEventListener("click", (e) => {
  if (!popup.contains(e.target)) {
    closePopup();
  }
});

function closePopup() {
  popup.classList.add("hidden");
  overlay.classList.add("hidden");
  overlay.style.display = "none";
}

function openMobileDraftOrder() {
  document.body.classList.add("mobile-draft-order-open");
  document.querySelector(".mobile-draft-order-summary").style.display = "block";
}

function closeMobileDraftOrder() {
  document.body.classList.remove("mobile-draft-order-open");
  document.querySelector(".mobile-draft-order-summary").style.display = "none";
}

// Handle opening and closing the draft order summary
document
  .querySelector(".view-draft-order-button")
  .addEventListener("click", () => {
    document
      .querySelector(".view-draft-order-button")
      .classList.remove("visible");
    document
      .querySelector(".mobile-draft-order-summary")
      .classList.remove("hidden");
    document
      .querySelector(".mobile-draft-order-summary")
      .classList.add("visible");
    openMobileDraftOrder();
  });

document
  .querySelector(".close-draft-order-summary")
  .addEventListener("click", () => {
    document
      .querySelector(".mobile-draft-order-summary")
      .classList.remove("visible");
    setTimeout(() => {
      toggleMobileDraftOrderButton(); // Show button again after animation
    }, 300); // Matches CSS transition
    closeMobileDraftOrder();
  });